import { ActionTypes } from '../constants';
import * as D from '../deps';

import * as DiscoveryWorkers from './workers';

export default [
  {
    actionType: ActionTypes.GET_BROWSE_DIRECTORY,
    handler: DiscoveryWorkers.getBrowseDirectory,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.PLS_GET_DIRECTORY_SUCCESS,
    handler: DiscoveryWorkers.onPLSGetDirectorySuccess,
    concur: 'takeEvery',
  },
];
